import * as $            from 'jquery';
import LoginFields       from '../Fields/LoginFields';
import ServiceREST       from 'Core/ServiceREST';
import Spinner           from 'Core/Spinner';
import { Notifications } from 'Core/Notifications';
import {initReCaptcha} from "../../Functions/InitReCaptcha";
import ReCaptchaValidation from "Components/Validation/ReCaptchaValidation";

export default class LoginFormValidation extends ServiceREST {
    readonly Selector: any;
    readonly view: string;
    spinner: typeof Spinner;

    captchaVisible: boolean;

    constructor(spinner: typeof Spinner) {
        super();
        super.rest    = this.rest.bind(this);
        this.validate = this.validate.bind(this);
        this.submit   = this.submit.bind(this);
        this.Selector = {
            FORM:           '#loginForm',
            SUBMIT_BUTTON:  '#submitLoginForm',
            LOGIN_INPUT:    '#loginEmail',
            PASSWORD_INPUT: '#loginPassword',
            SPINNER:        '#login-panel-small-spinner',
            RECAPTCHA:      '#g-recaptcha-login-form',
            RECAPTCHA_ERROR_MSG: '.g-recaptcha-error',
            RECAPTCHA_RESPONSE: '[name=g-recaptcha-response]'
        };
        this.spinner  = spinner;
    }

    private getActiveForm(): JQuery<HTMLElement> {
        // Find the visible login form (there may be multiple due to mobile/desktop headers)
        // Use attribute selector to get all elements with this ID (jQuery's #id only returns first)
        return $('[id="loginForm"]').filter(':visible').first();
    }

    public validate() {
        const $form = this.getActiveForm();
        $form.validate({
            rules: LoginFields.getFields(),
        });
        return $form.valid();
    }

    public async submit() {
        const $form = this.getActiveForm();
        if (!$form.length) return;
        
        const formId = $form.attr('id');
        const $loginInput = $form.find('[id="loginEmail"]');
        const $passwordInput = $form.find('[id="loginPassword"]');
        const $spinner = $form.find('[id="login-panel-small-spinner"]');
        const $recaptcha = $form.find('[id="g-recaptcha-login-form"]');
        const $recaptchaError = $form.find('.g-recaptcha-error');
        const $recaptchaResponse = $form.find('[name=g-recaptcha-response]');
        
        let login: any    = $loginInput.val();
        let password: any = $passwordInput.val();
        let url = $form.attr('data-api-url');

        let data = {
            user_email:    $loginInput.val(),
            user_password: $passwordInput.val(),
        };

        this.captchaVisible = Boolean($recaptchaResponse.length > 0 && $recaptchaResponse.is(':visible'));

        if (this.captchaVisible) {
            let response = String($recaptchaResponse.val());
            if (response.length == 0) {
                $recaptchaError.text($.validator.messages.reCaptcha).addClass("invalid-feedback").show();
                if (!$recaptcha.hasClass("error")) {
                    $recaptcha.addClass("error");
                }
                return;
            } else {
                $recaptchaError.text('');
                $recaptcha.removeClass("error");
                data['recaptcha'] = response;
                grecaptcha.reset();
            }
        }

        if (this.validate()) {
            if (login.length > 0 && password.length > 0) {
                this.spinner.smallSpinner($spinner, true);

                let checkLoginResponse = await this.rest('post', url, data);

                if (checkLoginResponse !== true) {
                    if (typeof (checkLoginResponse) == 'object') {
                        Notifications.add(checkLoginResponse.msg, 'error', {lifespan: 4000});
                        if (checkLoginResponse.reload) {
                            location.reload();
                        }

                        if (checkLoginResponse.counter >= 5) {
                            initReCaptcha($recaptcha);
                            this.captchaVisible = true;
                        }

                    } else {
                        Notifications.add(checkLoginResponse, 'error', {lifespan: 4000});
                    }


                    this.spinner.smallSpinner($spinner, false);
                } else {
                    $form.submit();
                }
            }
        }
    }

    public onClick() {
        $('body').on('click', this.Selector.SUBMIT_BUTTON, this.submit);
    }

    public onEnterPressed() {
        $('body').on('keypress', this.Selector.FORM, (e) => {
            if (e.keyCode == 13) {
                this.submit();
                e.preventDefault();
            }
        });
    }

}
const loginFormValidation = new LoginFormValidation(Spinner);
import * as $            from 'jquery';
import LoginFields       from '../Fields/LoginFields';
import ServiceREST       from 'Core/ServiceREST';
import Spinner           from 'Core/Spinner';
import { Notifications } from 'Core/Notifications';
import {initReCaptcha} from "../../Functions/InitReCaptcha";
import ReCaptchaValidation from "Components/Validation/ReCaptchaValidation";

export default class LoginFormValidation extends ServiceREST {
    readonly Selector: any;
    readonly view: string;
    spinner: typeof Spinner;

    captchaVisible: boolean;

    constructor(spinner: typeof Spinner) {
        super();
        super.rest    = this.rest.bind(this);
        this.validate = this.validate.bind(this);
        this.submit   = this.submit.bind(this);
        this.Selector = {
            FORM:           '#loginForm',
            SUBMIT_BUTTON:  '#submitLoginForm',
            LOGIN_INPUT:    '#loginEmail',
            PASSWORD_INPUT: '#loginPassword',
            SPINNER:        '#login-panel-small-spinner',
            RECAPTCHA:      '#g-recaptcha-login-form',
            RECAPTCHA_ERROR_MSG: '.g-recaptcha-error',
            RECAPTCHA_RESPONSE: '[name=g-recaptcha-response]'
        };
        this.spinner  = spinner;
    }

    private getActiveForm(): JQuery<HTMLElement> {
        // Find the visible login form (there may be multiple due to mobile/desktop headers)
        // Use attribute selector to get all elements with this ID (jQuery's #id only returns first)
        return $('[id="loginForm"]').filter(':visible').first();
    }

    public validate() {
        const $form = this.getActiveForm();
        $form.validate({
            rules: LoginFields.getFields(),
        });
        return $form.valid();
    }

    public async submit() {
        const $form = this.getActiveForm();
        if (!$form.length) return;
        
        const formId = $form.attr('id');
        const $loginInput = $form.find('[id="loginEmail"]');
        const $passwordInput = $form.find('[id="loginPassword"]');
        const $spinner = $form.find('[id="login-panel-small-spinner"]');
        const $recaptcha = $form.find('[id="g-recaptcha-login-form"]');
        const $recaptchaError = $form.find('.g-recaptcha-error');
        const $recaptchaResponse = $form.find('[name=g-recaptcha-response]');
        
        let login: any    = $loginInput.val();
        let password: any = $passwordInput.val();
        let url = $form.attr('data-api-url');

        let data = {
            user_email:    $loginInput.val(),
            user_password: $passwordInput.val(),
        };

        this.captchaVisible = Boolean($recaptchaResponse.length > 0 && $recaptchaResponse.is(':visible'));

        if (this.captchaVisible) {
            let response = String($recaptchaResponse.val());
            if (response.length == 0) {
                $recaptchaError.text($.validator.messages.reCaptcha).addClass("invalid-feedback").show();
                if (!$recaptcha.hasClass("error")) {
                    $recaptcha.addClass("error");
                }
                return;
            } else {
                $recaptchaError.text('');
                $recaptcha.removeClass("error");
                data['recaptcha'] = response;
                grecaptcha.reset();
            }
        }

        if (this.validate()) {
            if (login.length > 0 && password.length > 0) {
                this.spinner.smallSpinner($spinner, true);

                let checkLoginResponse = await this.rest('post', url, data);

                if (checkLoginResponse !== true) {
                    if (typeof (checkLoginResponse) == 'object') {
                        Notifications.add(checkLoginResponse.msg, 'error', {lifespan: 4000});
                        if (checkLoginResponse.reload) {
                            location.reload();
                        }

                        if (checkLoginResponse.counter >= 5) {
                            initReCaptcha($recaptcha);
                            this.captchaVisible = true;
                        }

                    } else {
                        Notifications.add(checkLoginResponse, 'error', {lifespan: 4000});
                    }


                    this.spinner.smallSpinner($spinner, false);
                } else {
                    $form.submit();
                }
            }
        }
    }

    public onClick() {
        $('body').on('click', this.Selector.SUBMIT_BUTTON, this.submit);
    }

    public onEnterPressed() {
        $('body').on('keypress', this.Selector.FORM, (e) => {
            if (e.keyCode == 13) {
                this.submit();
                e.preventDefault();
            }
        });
    }

}
const loginFormValidation = new LoginFormValidation(Spinner);
